function StatusChip({ label, tone = "neutral" }) {
  const toneMap = {
    success: {
      background: "#0f2416",
      color: "#7CFC00",
      border: "#1f5d34",
    },
    warning: {
      background: "#2a1d08",
      color: "#ffb020",
      border: "#5a3e0c",
    },
    danger: {
      background: "#2a1111",
      color: "#ff8f8f",
      border: "#6b1d1d",
    },
    info: {
      background: "#0d2033",
      color: "#4da3ff",
      border: "#1d4670",
    },
    neutral: {
      background: "#151515",
      color: "#d1d1d1",
      border: "#2a2a2a",
    },
  };

  const style = toneMap[tone] || toneMap.neutral;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 12px",
        borderRadius: "999px",
        fontSize: "13px",
        fontWeight: "bold",
        background: style.background,
        color: style.color,
        border: `1px solid ${style.border}`,
      }}
    >
      {label}
    </span>
  );
}

export default StatusChip;